// GENERATED from bb-layout-engine.js by build-global.mjs; do not edit.
// Classic-script build: <script src="bb-layout-engine.global.js"></script> sets window.BBLayout.
(function () {
"use strict";
/*
 * Badge Buddy title layout engine (BB placement rules v1), browser port.
 *
 * Line-for-line port of scripts/bb_layout_engine.py (production).  Reads only
 * the layout pack (data/bb_automation/bb_layout_pack.json); never measures
 * fonts in the browser.  Must pass tests/fixtures/bb_layout_golden.json
 * (see test/golden.test.mjs).
 *
 * Coordinates: inches; x from the die centre (left edge of the line's
 * advance box), y measured UP from the bottom cut.  Font sizes in pt.
 *
 * Per-line fonts (Simon 2026-10-10): opts.font is Line 1's font, opts.font2
 * Line 2's (default opts.font; a lone Line 2 is set in font2).  Every per-line
 * measurement uses that line's font.  Two matched lines in DIFFERENT fonts
 * follow the pack rule rules.mixed_font_equal_size ("point" = production's
 * smaller point size, "cap" = the smaller cap height), or opts.mixedFontEqualSize.
 * One font gives exactly the single-font result in either mode.
 *
 * Approved acronyms (Simon 2026-10-10): the pack carries production's list;
 * withAcronyms(pack, list) / pack.with_acronyms(list) / loadPack(json,
 * {acronyms}) use another list (the shop metafield
 * shop.metafields.custom.bb_approved_acronyms) when it is valid
 * (validateAcronyms: a non-empty array, or its JSON text, of at most
 * MAX_APPROVED_ACRONYMS strings matching ^[A-Z0-9]+$), else the pack's own
 * list.  Same rule as production's validate_acronym_list.
 *
 * Float parity notes (keep when editing):
 *  - Every arithmetic expression keeps Python's evaluation order
 *    (a * b / c is (a * b) / c; -d * f is (-d) * f).
 *  - production font sizes use Python round(x, 1): correctly rounded on
 *    the exact binary value, ties to even (pyRound1 below), not Math.round.
 *  - Text is iterated by Unicode code point (for..of), like Python str.
 *  - Line widths sum integer 1/1000 em advances; loadPack rejects a pack
 *    whose pdf advances are not integers, so the sum is exact in both.
 *  - Python raises ZeroDivisionError where JS would give Infinity; pyDiv
 *    throws instead.
 *
 * Usage (ES module):
 *   import { loadPack, layoutTitle } from './bb-layout-engine.js';
 * Usage (no import): <script type="module" src="bb-layout-engine.js"></script>
 *   then window.BBLayout.loadPack / window.BBLayout.layoutTitle, or load the
 *   classic-script build bb-layout-engine.global.js (generated, same code).
 */

const ENGINE_VERSION = "bb-layout-engine-js 4 (port of scripts/bb_layout_engine.py, bb-placement-rules-v1, per-line fonts, acronym override, enlarge, badge bottom)";

const PT = 72.0;
const MM = 1.0 / 25.4;
const STYLES = ["box", "bleed", "bottom"];
const MIXED_FONT_MODES = ["point", "cap"];
const TOKEN_RE = /[A-Za-z0-9]+/g;
const MAX_APPROVED_ACRONYMS = 500;
const ACRONYM_ENTRY_RE = /^[A-Z0-9]+$/;

class LayoutPackError extends Error {
  constructor(message) {
    super(message);
    this.name = "LayoutPackError";
  }
}

// ------------------------------------------------------------ Python helpers

/** Python ``str(x or "")`` for the values a form can produce. */
function pyStr(x) {
  if (x === undefined || x === null || x === false || x === 0 || x === "") return "";
  if (x === true) return "True";
  return String(x);
}

/** Python true division: raises on a zero divisor instead of returning Infinity. */
function pyDiv(a, b) {
  if (b === 0) throw new RangeError("float division by zero");
  return a / b;
}

/**
 * Python ``round(x, 1)`` / ``format(x, ".1f")``.
 *
 * Number.prototype.toFixed rounds the exact binary value correctly but breaks
 * exact ties upward; Python breaks them to even.  An exact tie at one decimal
 * needs x = m/4 with m odd (x.25 / x.75), so only those values are fixed up.
 */
function pyFormat1(x) {
  if (!Number.isFinite(x) || Math.abs(x) >= 1e15) {
    throw new RangeError(`pyFormat1 supports finite |x| < 1e15, got ${x}`);
  }
  const q = x * 4; // exact (power-of-two scaling)
  if (Number.isInteger(q) && q % 2 !== 0) {
    const tenths = q * 2.5; // exact: q is a small odd integer, result is k + 0.5
    let n = Math.floor(Math.abs(tenths));
    if (n % 2 !== 0) n += 1; // ties to even
    const neg = x < 0 || Object.is(x, -0);
    return `${neg ? "-" : ""}${Math.floor(n / 10)}.${n % 10}`;
  }
  return x.toFixed(1);
}

function pyRound1(x) {
  return parseFloat(pyFormat1(x));
}

/** Python ``format(x, "g")`` (6 significant digits). */
function pyFormatG(x) {
  if (x === 0) return Object.is(x, -0) ? "-0" : "0";
  if (!Number.isFinite(x)) return Number.isNaN(x) ? "nan" : x > 0 ? "inf" : "-inf";
  const [mant, expStr] = x.toExponential(5).split("e");
  const exp = parseInt(expStr, 10);
  const strip = (s) => (s.includes(".") ? s.replace(/0+$/, "").replace(/\.$/, "") : s);
  if (exp >= -4 && exp < 6) return strip(x.toFixed(5 - exp));
  const sign = exp < 0 ? "-" : "+";
  return `${strip(mant)}e${sign}${String(Math.abs(exp)).padStart(2, "0")}`;
}

const NON_PRINTABLE_RE = /^[\p{Cc}\p{Cf}\p{Cs}\p{Co}\p{Cn}\p{Zl}\p{Zp}\p{Zs}]$/u;

/** Python ``repr(str)`` (used verbatim in review_reasons). */
function pyRepr(s) {
  const q = s.includes("'") && !s.includes('"') ? '"' : "'";
  let out = q;
  for (const ch of s) {
    const cp = ch.codePointAt(0);
    if (ch === q || ch === "\\") out += "\\" + ch;
    else if (ch === "\t") out += "\\t";
    else if (ch === "\n") out += "\\n";
    else if (ch === "\r") out += "\\r";
    else if (cp < 0x20 || cp === 0x7f) out += "\\x" + cp.toString(16).padStart(2, "0");
    else if (cp < 0x7f) out += ch;
    else if (ch !== " " && NON_PRINTABLE_RE.test(ch)) {
      if (cp <= 0xff) out += "\\x" + cp.toString(16).padStart(2, "0");
      else if (cp <= 0xffff) out += "\\u" + cp.toString(16).padStart(4, "0");
      else out += "\\U" + cp.toString(16).padStart(8, "0");
    } else out += ch;
  }
  return out + q;
}

/** Python ``sorted(set(chars))``: code-point order, not UTF-16 order. */
function sortedCodePoints(chars) {
  return [...new Set(chars)].sort((a, b) => a.codePointAt(0) - b.codePointAt(0));
}

/**
 * Production's whitespace trim (Python ``str.strip()``), applied to line 1 /
 * line 2 when orders are ingested.  layoutTitle itself does NOT trim, exactly
 * like the Python engine; call this first on raw customer input.
 */
const PY_SPACE = "\t\n\v\f\r\x1c\x1d\x1e\x1f \x85\xa0                　";
function productionStrip(text) {
  const s = pyStr(text);
  let a = 0;
  let b = s.length;
  while (a < b && PY_SPACE.includes(s[a])) a += 1;
  while (b > a && PY_SPACE.includes(s[b - 1])) b -= 1;
  return s.slice(a, b);
}

// ------------------------------------------------------------ pack

class FontMetrics {
  constructor(label, entry) {
    this.label = label;
    this.upem = Number(entry.units_per_em);
    this.cap_em = entry.cap_height_units / this.upem;
    this._glyphs = new Map(Object.entries(entry.glyphs));
    this._notdef = entry.notdef;
  }

  has(ch) {
    return this._glyphs.has(ch);
  }

  _g(ch) {
    return this._glyphs.get(ch) || this._notdef;
  }

  missing(text) {
    return sortedCodePoints([...text].filter((ch) => !this._glyphs.has(ch)));
  }

  /** Advance width in inches, same arithmetic as fpdf2 get_string_width. */
  pdf_width_in(text, fontSize) {
    let sum = 0; // integer advances: exact, same as Python's int sum
    for (const ch of text) sum += this._g(ch)[1];
    return ((sum * fontSize) * 0.001) / PT;
  }

  /** [top, bottom] of the line's ink in em, y up; [0, 0] when no ink. */
  ink_y_em(text) {
    let top = null;
    let bot = null;
    for (const ch of text) {
      const g = this._g(ch);
      if (g[2] !== null) {
        if (top === null || g[5] > top) top = g[5];
        if (bot === null || g[3] < bot) bot = g[3];
      }
    }
    if (top === null) return [0.0, 0.0];
    return [top / this.upem, bot / this.upem];
  }

  /** [ink left, ink right, total advance] in em (pen from advance_units, no kerning). */
  ink_x_em(text) {
    let lo = null;
    let hi = null;
    let pen = 0.0;
    for (const ch of text) {
      const g = this._g(ch);
      if (g[2] !== null) {
        const a = pen + g[2] / this.upem;
        const b = pen + g[4] / this.upem;
        lo = lo === null ? Math.min(a, b) : Math.min(lo, a, b);
        hi = hi === null ? Math.max(a, b) : Math.max(hi, a, b);
      }
      pen += g[0] / this.upem;
    }
    if (lo === null) return [0.0, 0.0, pen];
    return [lo, hi, pen];
  }
}

class LayoutPack {
  constructor(data, source = "<object>") {
    if (!data || data.schema !== "bb-layout-pack") {
      throw new LayoutPackError(`${source}: not a bb-layout-pack`);
    }
    for (const [label, entry] of Object.entries(data.fonts || {})) {
      for (const [ch, g] of [...Object.entries(entry.glyphs), [".notdef", entry.notdef]]) {
        if (!Number.isInteger(g[0]) || !Number.isInteger(g[1])) {
          throw new LayoutPackError(`${source}: ${label} ${JSON.stringify(ch)} advances must be integers`);
        }
      }
    }
    this.data = data;
    this.source = source;
    this.rules = data.rules;
    this.dies = data.dies;
    this.sizing = data.sizing;
    this.acronyms = new Set(data.approved_acronyms);
    this.acronyms_source = "pack";
    this.min_font_pt = Number(this.rules.min_font_pt);
    this.min_font_pt_with_acronym = Number(
      this.rules.min_font_pt_with_acronym !== undefined ? this.rules.min_font_pt_with_acronym : this.min_font_pt,
    );
    this.enlarge_min_gain = Number(this.rules.enlarge_min_gain !== undefined ? this.rules.enlarge_min_gain : 0.1);
    this.mixed_font_equal_size = mixedMode(
      this.rules.mixed_font_equal_size !== undefined ? this.rules.mixed_font_equal_size : "point",
    );
    this._fonts = new Map();
  }

  get font_labels() {
    return Object.keys(this.data.fonts);
  }

  font(label) {
    if (!this._fonts.has(label)) {
      if (!Object.prototype.hasOwnProperty.call(this.data.fonts, label)) {
        throw new LayoutPackError(`font ${pyRepr(String(label))} not in pack; have ${JSON.stringify(this.font_labels)}`);
      }
      this._fonts.set(label, new FontMetrics(label, this.data.fonts[label]));
    }
    return this._fonts.get(label);
  }

  die(orientation, sizeClass) {
    const key = `${orientation}-${sizeClass}`;
    if (!Object.prototype.hasOwnProperty.call(this.dies, key)) throw new LayoutPackError(`no die ${key}`);
    return this.dies[key];
  }

  card_bottom_from_cut(orientation) {
    return Number(this.rules.card.card_bottom_from_cut_in[orientation]);
  }

  strip_bottom_inset(orientation) {
    return Number(this.rules.strip.bottom_inset_from_cut_in[orientation]);
  }

  /**
   * This pack with `acronyms` as its approved list when valid (see
   * validateAcronyms), else this pack unchanged.  The copy shares the pack data
   * and font metrics and has acronyms_source "override".
   */
  with_acronyms(acronyms) {
    const valid = validateAcronyms(acronyms);
    if (valid === null) return this;
    const pack = Object.create(Object.getPrototypeOf(this));
    Object.assign(pack, this);
    pack.acronyms = new Set(valid);
    pack.acronyms_source = "override";
    return pack;
  }

  /** True when every [A-Za-z0-9]+ token of the upper-cased text is an approved acronym. */
  is_approved_acronym(text) {
    const tokens = pyStr(text).toUpperCase().match(TOKEN_RE) || [];
    return tokens.length > 0 && tokens.every((t) => this.acronyms.has(t));
  }

  should_match_sizes(line1, line2) {
    if (!line1 || !line2) return false;
    return !(this.is_approved_acronym(line1) || this.is_approved_acronym(line2));
  }
}

/**
 * The approved-acronym list as a new array when `value` is valid, else null.
 * `value` is an array or its JSON text (a shop metafield of type json).
 * Valid = non-empty, at most MAX_APPROVED_ACRONYMS entries, every entry a
 * string of upper-case A-Z / 0-9 only.  Same rule as production's
 * validate_acronym_list (scripts/bb_layout_engine.py).
 */
function validateAcronyms(value) {
  if (typeof value === "string") {
    try {
      value = JSON.parse(value);
    } catch (e) {
      return null;
    }
  }
  if (!Array.isArray(value) || value.length === 0 || value.length > MAX_APPROVED_ACRONYMS) return null;
  for (const v of value) {
    if (typeof v !== "string" || !ACRONYM_ENTRY_RE.test(v)) return null;
  }
  return value.slice();
}

/** The pack with `acronyms` as its approved list when valid, else the pack's own list. */
function withAcronyms(pack, acronyms) {
  return asPack(pack).with_acronyms(acronyms);
}

/**
 * Load the layout pack from its parsed JSON object or the JSON text.
 * loadPack(json, source) or loadPack(json, { source, acronyms }) /
 * loadPack(json, source, { acronyms }): `acronyms` (e.g. the shop metafield
 * custom.bb_approved_acronyms) replaces the pack's list when valid; absent or
 * invalid keeps the pack's list.
 */
function loadPack(json, source, options) {
  if (source && typeof source === "object") {
    options = source;
    source = options.source;
  }
  const acronyms = options ? options.acronyms : undefined;
  let pack;
  if (json instanceof LayoutPack) {
    pack = json;
  } else {
    const data = typeof json === "string" ? JSON.parse(json) : json;
    pack = new LayoutPack(data, source || (typeof json === "string" ? "<json text>" : "<object>"));
  }
  return acronyms === undefined ? pack : pack.with_acronyms(acronyms);
}

function asPack(pack) {
  return pack instanceof LayoutPack ? pack : loadPack(pack);
}

function normOrientation(o) {
  const first = [...pyStr(o).toUpperCase()][0] || "";
  if (first !== "H" && first !== "V") {
    throw new LayoutPackError(`orientation must be H or V, got ${pyRepr(first)}`);
  }
  return first;
}

function mixedMode(mode) {
  if (!MIXED_FONT_MODES.includes(mode)) {
    throw new LayoutPackError(
      `mixed_font_equal_size must be one of ('point', 'cap'), got ${typeof mode === "string" ? pyRepr(mode) : String(mode)}`,
    );
  }
  return mode;
}

/** Normalise to [top, bottom]; a lone Line 2 is laid out as the single line. */
function normLines(line1, line2) {
  const a = pyStr(line1);
  const b = pyStr(line2);
  if (!a && b) return [b, ""];
  return [a, b];
}

// ------------------------------------------------------------ sizing

/**
 * Port of BadgeSizer.calculate_direct (production sizing, STD profile).
 * Returns [fs1, fs2] for the lines as given (a lone Line 2 returns [0, fs2]).
 * font measures Line 1, font2 (default font) Line 2; mixedFontEqualSize
 * (default: the pack rule) applies to two matched lines in different fonts.
 * enlarge: size the two lines on their own, as for an approved acronym line
 * ("make it bigger").
 */
function productionFontSizes(pack, font, orientation, line1, line2, font2, mixedFontEqualSize, enlarge) {
  pack = asPack(pack);
  line1 = pyStr(line1);
  line2 = pyStr(line2);
  const o = normOrientation(orientation);
  if (font2 === undefined || font2 === null) font2 = font;
  const F1 = pack.font(font);
  const F2 = pack.font(font2);
  const mode =
    mixedFontEqualSize === undefined || mixedFontEqualSize === null ? pack.mixed_font_equal_size : mixedMode(mixedFontEqualSize);
  const p = pack.sizing[o];
  const maxW = p.badge_width_in - 2 * p.title_inset_side_in - p.width_padding_in;
  const maxH = p.title_height_in - p.height_padding_in;
  const ref = p.reference_size_pt;

  const maxFsForWidth = (text, F) => {
    const w = text ? F.pdf_width_in(text, ref) : 0.0;
    if (w <= 0) return p.max_font_single_pt;
    return (ref * maxW) / w;
  };

  const lo = p.min_computed_size_pt;
  let fs1;
  let fs2;
  if (line1 && !line2) {
    fs1 = Math.max(Math.min(Math.min(maxFsForWidth(line1, F1), p.max_font_single_pt), maxH * 72), lo);
    fs2 = 0.0;
  } else if (line2 && !line1) {
    fs2 = Math.max(Math.min(Math.min(maxFsForWidth(line2, F2), p.max_font_single_pt), maxH * 72), lo);
    fs1 = 0.0;
  } else if (line1 && line2) {
    const maxFsHeight = maxH * p.two_line_height_share * 72;
    fs1 = Math.min(maxFsForWidth(line1, F1), maxFsHeight, p.max_font_line1_pt);
    fs2 = Math.min(maxFsForWidth(line2, F2), maxFsHeight, p.max_font_line2_pt);
    if (!enlarge && pack.should_match_sizes(line1, line2)) {
      if (font2 === font || mode === "point") {
        fs1 = fs2 = Math.min(fs1, fs2);
      } else {
        // "cap": the same cap height, so the lines look equally big
        const cap = Math.min(fs1 * F1.cap_em, fs2 * F2.cap_em);
        fs1 = cap / F1.cap_em;
        fs2 = cap / F2.cap_em;
      }
    }
    if (fs1 + fs2 > p.max_sum_font_pt) {
      const ratio = p.max_sum_font_pt / (fs1 + fs2);
      fs1 *= ratio;
      fs2 *= ratio;
    }
    fs1 = Math.max(fs1, lo);
    fs2 = Math.max(fs2, lo);
  } else {
    return [0.0, 0.0];
  }
  return [pyRound1(fs1), pyRound1(fs2)];
}

function isApprovedAcronym(pack, text) {
  return asPack(pack).is_approved_acronym(text);
}

// ------------------------------------------------------------ box (variant B)

function layoutBox(pack, F1, F2, o, l1, l2, fs1, fs2, stripInset) {
  const box = pack.rules.box;
  const upper = pack.card_bottom_from_cut(o) - pack.rules.card.margin_below_card_in;
  const gap = box.ink_gap_pt[o] / PT;
  const share = box.descender_inset_share;
  const tol = box.ceiling_tolerance_in;
  const [t1, d1] = F1.ink_y_em(l1);
  const [t2, d2] = l2 ? F2.ink_y_em(l2) : [0.0, 0.0];
  let scale = 1.0;
  let steps = 0;
  let f1;
  let f2;
  let b1;
  let b2;
  for (;;) {
    f1 = fs1 * scale;
    f2 = fs2 * scale;
    if (l2) {
      const m = box.two_line_bottom_inset_in[o];
      const lift = Math.max(0.0, ((-d2) * f2) / PT - share * m);
      b2 = stripInset + m + lift;
      const top2 = b2 + (t2 * f2) / PT;
      b1 = top2 + gap + ((-d1) * f1) / PT;
    } else {
      const m = box.single_line_inset_a_in[o] + (box.single_line_inset_b_per_in[o] * f1) / PT;
      const lift = Math.max(0.0, ((-d1) * f1) / PT - share * m);
      b1 = stripInset + m + lift;
      b2 = null;
    }
    const top1 = b1 + (t1 * f1) / PT;
    if (top1 <= upper + tol || steps > box.shrink_max_steps) break;
    scale *= box.shrink_step;
    steps += 1;
  }
  return [f1, l2 ? f2 : 0.0, b1, b2, scale, 0.0];
}

// ------------------------------------------------------------ full bleed

function bleedPlace(pack, F1, F2, o, l1, l2, s, r) {
  const bl = pack.rules.bleed;
  const f1 = s;
  const f2 = l2 ? pyDiv(s, r) : 0.0;
  const [, d1] = F1.ink_y_em(l1);
  const dy = l2 ? ((-d1) * f1 + bl.ink_gap_pt[o] + F2.ink_y_em(l2)[0] * f2) / PT : 0.0;
  const card = pack.card_bottom_from_cut(o);
  const mid = card / 2.0;
  let b1 = mid + dy / 2.0 - (F1.cap_em * f1) / PT / 2.0;
  const [lt, lf, LF] = l2 ? [l2, f2, F2] : [l1, f1, F1];
  const lowest = b1 - dy + (LF.ink_y_em(lt)[1] * lf) / PT;
  const floor = bl.bottom_margin_mm * MM;
  const shift = Math.max(0.0, floor - lowest);
  b1 += shift;
  return [f1, f2, b1, l2 ? b1 - dy : null, shift];
}

function bleedOk(pack, F1, F2, o, l1, l2, f1, f2, b1, dieW) {
  const bl = pack.rules.bleed;
  const upper = pack.card_bottom_from_cut(o) - pack.rules.card.margin_below_card_in;
  const tol = bl.tolerance_in;
  const inkTop = b1 + (F1.ink_y_em(l1)[0] * f1) / PT;
  const boxW = dieW - 2 * bl.side_margin_mm * MM;
  let w = 0.0;
  for (const [t, f, F] of [[l1, f1, F1], [l2, f2, F2]]) {
    if (t) {
      const [il, ir, adv] = F.ink_x_em(t);
      w = Math.max(w, (2 * Math.max(adv / 2 - il, ir - adv / 2) * f) / PT);
    }
  }
  return inkTop <= upper + tol && w <= boxW + tol;
}

function layoutBleed(pack, F1, F2, o, l1, l2, fs1, fs2, dieW) {
  const bl = pack.rules.bleed;
  const r = l2 ? pyDiv(fs1, fs2) : 1.0;
  let lo = bl.search_lo_pt;
  let hi = bl.search_hi_pt;
  for (let i = 0; i < bl.search_iterations; i += 1) {
    const s = (lo + hi) / 2;
    const [f1, f2, b1] = bleedPlace(pack, F1, F2, o, l1, l2, s, r);
    if (bleedOk(pack, F1, F2, o, l1, l2, f1, f2, b1, dieW)) lo = s;
    else hi = s;
  }
  const [f1, f2, b1, b2, shift] = bleedPlace(pack, F1, F2, o, l1, l2, lo, r);
  return [f1, f2, b1, b2, pyDiv(f1, fs1), shift];
}

// ------------------------------------------------------------ Badge Bottom

function bottomPlace(pack, F1, F2, o, l1, l2, f1, f2, dieH) {
  const bt = pack.rules.bottom;
  const dy = l2 ? ((-F1.ink_y_em(l1)[1]) * f1 + bt.ink_gap_pt[o] + F2.ink_y_em(l2)[0] * f2) / PT : 0.0;
  let b1 = dieH / 2.0 + dy / 2.0 - (F1.cap_em * f1) / PT / 2.0;
  const [lt, lf, LF] = l2 ? [l2, f2, F2] : [l1, f1, F1];
  const lowest = b1 - dy + (LF.ink_y_em(lt)[1] * lf) / PT;
  b1 += Math.max(0.0, bt.top_bottom_margin_mm * MM - lowest);
  return [b1, l2 ? b1 - dy : null];
}

// Point maximum multiplier for font F: the same capital height as rules.bottom.max_reference_font.
function bottomCapFactor(pack, F) {
  const bt = pack.rules.bottom;
  if (bt.max_by !== "cap_height") return 1.0;
  return pack.font(bt.max_reference_font).cap_em / F.cap_em;
}

function layoutBottom(pack, F1, F2, o, l1, l2, fs1, fs2, dieW, dieH) {
  const bt = pack.rules.bottom;
  const tol = bt.tolerance_in;
  const r = l2 ? pyDiv(fs1, fs2) : 1.0;
  const k1 = bottomCapFactor(pack, F1);
  const k2 = bottomCapFactor(pack, F2);
  const sizes = (s) => [s, l2 ? pyDiv(s, r) : 0.0];
  const ok = (s) => {
    const [f1, f2] = sizes(s);
    const [b1] = bottomPlace(pack, F1, F2, o, l1, l2, f1, f2, dieH);
    if (b1 + (F1.ink_y_em(l1)[0] * f1) / PT > dieH - bt.top_bottom_margin_mm * MM + tol) return false;
    for (const [t, f, F] of [[l1, f1, F1], [l2, f2, F2]]) {
      if (t) {
        const [il, ir, adv] = F.ink_x_em(t);
        if ((2 * Math.max(adv / 2 - il, ir - adv / 2) * f) / PT > dieW - 2 * bt.side_margin_mm * MM + tol) return false;
      }
    }
    return Math.max(f1 / k1, l2 ? f2 / k2 : 0.0) <= bt.max_font_pt + tol;
  };
  let lo = bt.search_lo_pt;
  let hi = bt.search_hi_pt;
  for (let i = 0; i < bt.search_iterations; i += 1) {
    const s = (lo + hi) / 2;
    if (ok(s)) lo = s;
    else hi = s;
  }
  let [f1, f2] = sizes(lo);
  if (l2) {
    f1 = Math.min(f1, bt.two_line_max_font_pt * k1);
    f2 = Math.min(f2, bt.two_line_max_font_pt * k2);
  }
  const [b1, b2] = bottomPlace(pack, F1, F2, o, l1, l2, f1, f2, dieH);
  return [f1, f2, b1, b2, fs1 ? pyDiv(f1, fs1) : 1.0, 0.0];
}

// ------------------------------------------------------------ public API

function opt(opts, camel, snake) {
  if (opts[camel] !== undefined) return opts[camel];
  return opts[snake];
}

/**
 * Lay out one Badge Buddy title.
 *
 * opts: { font, font2 = font, orientation ('H'|'V'), line1, line2 = '', style = 'box'|'bleed',
 *         sizeClass = 'STD'|'XL'|'BBOTTOM' (style 'bottom'), fontSizes?: [fs1, fs2], dieWidthIn?,
 *         dieHeightIn? (bottom only), stripBottomInsetIn?,
 *         mixedFontEqualSize?: 'point'|'cap', enlarge?: boolean }
 * (snake_case aliases size_class, font_sizes, die_width_in, strip_bottom_inset_in,
 *  mixed_font_equal_size are accepted, so golden-file inputs can be passed straight in.)
 * font is Line 1's font, font2 Line 2's; a lone Line 2 is set in font2.
 *
 * Returns the same object as Python layout_title (snake_case keys).
 */
function layoutTitle(pack, opts = {}) {
  pack = asPack(pack);
  const o = normOrientation(opts.orientation);
  const sizeClass = pyStr(opt(opts, "sizeClass", "size_class") || "STD").toUpperCase();
  const style = opts.style === undefined ? "box" : opts.style;
  if (!STYLES.includes(style)) {
    throw new LayoutPackError(`style must be one of ('box', 'bleed', 'bottom')`);
  }
  if ((style === "bottom") !== (sizeClass === "BBOTTOM")) {
    throw new LayoutPackError("style 'bottom' goes with size_class BBOTTOM (and only it)");
  }
  if (style === "bottom") opts = Object.assign({}, opts, { enlarge: false });
  const die = pack.die(o, sizeClass);
  const font = opts.font;
  const font2 = opts.font2 === undefined || opts.font2 === null ? font : opts.font2;
  const modeOpt = opt(opts, "mixedFontEqualSize", "mixed_font_equal_size");
  const mode = modeOpt === undefined || modeOpt === null ? pack.mixed_font_equal_size : mixedMode(modeOpt);
  const Fa = pack.font(font);
  const Fb = pack.font(font2);
  const raw1 = pyStr(opts.line1);
  const raw2 = pyStr(opts.line2);
  const [l1, l2] = normLines(raw1, raw2);
  const lone2 = !raw1 && !!raw2;
  // Fonts of the laid-out lines (top, bottom); a lone Line 2 is the top line.
  const [F1, F2] = lone2 ? [Fb, Fb] : [Fa, Fb];
  let fontSizes = opt(opts, "fontSizes", "font_sizes");
  if (fontSizes === undefined || fontSizes === null) {
    if (opts.enlarge) {
      const o2 = Object.assign({}, opts);
      delete o2.enlarge;
      delete o2.fontSizes;
      delete o2.font_sizes;
      fontSizes = enlargeFontSizes(pack, o2);
    } else {
      fontSizes = productionFontSizes(pack, font, o, raw1, raw2, font2, mode);
    }
  }
  let pfs1 = Number(fontSizes[0] || 0.0);
  let pfs2 = Number(fontSizes[1] || 0.0);
  if (lone2) {
    pfs1 = pfs2;
    pfs2 = 0.0;
  }
  const dieWidthIn = opt(opts, "dieWidthIn", "die_width_in");
  const stripInsetIn = opt(opts, "stripBottomInsetIn", "strip_bottom_inset_in");
  const dieW = Number(dieWidthIn !== undefined && dieWidthIn !== null ? dieWidthIn : die.die_width_in);
  const stripInset = Number(stripInsetIn !== undefined && stripInsetIn !== null ? stripInsetIn : pack.strip_bottom_inset(o));

  const miss1 = F1.missing(l1);
  const miss2 = l2 ? F2.missing(l2) : [];
  const result = {
    rules_version: pack.data.rules_version,
    font,
    font2,
    mixed_font_equal_size: mode,
    orientation: o,
    size_class: sizeClass,
    style,
    line1: raw1,
    line2: raw2,
    production_font_sizes: l2 ? [pfs1, pfs2] : [pfs1],
    lines: [],
    scale: 1.0,
    shift_in: 0.0,
    needs_review: false,
    review_reasons: [],
    missing_glyphs: sortedCodePoints([...miss1, ...miss2]),
  };
  if (opts.enlarge) result.enlarge = true;
  if (!l1) return result;
  const dieHeightIn = opt(opts, "dieHeightIn", "die_height_in");
  const dieH = Number(dieHeightIn !== undefined && dieHeightIn !== null ? dieHeightIn : die.die_height_in);
  const [f1, f2, b1, b2, scale, shift] =
    style === "box"
      ? layoutBox(pack, F1, F2, o, l1, l2, pfs1, pfs2, stripInset)
      : style === "bottom"
        ? layoutBottom(pack, F1, F2, o, l1, l2, pfs1, pfs2, dieW, dieH)
        : layoutBleed(pack, F1, F2, o, l1, l2, pfs1, pfs2, dieW);
  result.scale = scale;
  result.shift_in = shift;
  const card = pack.card_bottom_from_cut(o);
  const fields = lone2 ? [2, null] : [1, 2];
  for (const [text, fs, base, F, field, miss] of [
    [l1, f1, b1, F1, fields[0], miss1],
    [l2, f2, b2, F2, fields[1], miss2],
  ]) {
    if (!text) continue;
    const w = F.pdf_width_in(text, fs);
    const x = -w / 2.0;
    const [top, bot] = F.ink_y_em(text);
    const [il, ir] = F.ink_x_em(text);
    result.lines.push({
      text,
      font_size: fs,
      x_in: x,
      baseline_from_cut_in: base,
      width_in: w,
      ink_top_from_cut_in: base + (top * fs) / PT,
      ink_bottom_from_cut_in: base + (bot * fs) / PT,
      ink_left_in: x + (il * fs) / PT,
      ink_right_in: x + (ir * fs) / PT,
      font: F.label,
      field,
      missing_glyphs: miss,
    });
  }
  const lines = result.lines;
  let minSide = Infinity;
  for (const ln of lines) {
    const side = Math.min(ln.ink_left_in + dieW / 2, dieW / 2 - ln.ink_right_in);
    if (side < minSide) minSide = side;
  }
  result.metrics = {
    lowest_ink_mm: lines[lines.length - 1].ink_bottom_from_cut_in * 25.4,
    [style === "bottom" ? "top_ink_below_top_cut_mm" : "top_ink_below_card_mm"]:
      ((style === "bottom" ? dieH : card) - lines[0].ink_top_from_cut_in) * 25.4,
    min_side_mm: minSide * 25.4,
    base_to_cut_mm: lines.map((ln) => ln.baseline_from_cut_in * 25.4),
  };
  const floorFor = (i) => {
    const other = lines.length === 2 ? lines[1 - i].text : "";
    if (other && pack.is_approved_acronym(other) && !pack.is_approved_acronym(lines[i].text)) {
      return pack.min_font_pt_with_acronym;
    }
    return pack.min_font_pt;
  };
  const small = [];
  lines.forEach((ln, i) => {
    const fl = floorFor(i);
    if (ln.font_size < fl - 1e-9) small.push([ln, fl]);
  });
  if (small.length) {
    result.needs_review = true;
    result.review_reasons.push(
      "below_min_font: " +
        small.map(([ln, fl]) => `${pyRepr(ln.text)} ${pyFormat1(ln.font_size)} pt < ${pyFormatG(fl)} pt`).join(", "),
    );
  }
  if (result.missing_glyphs.length) {
    result.needs_review = true;
    let reason = "missing_glyphs: " + result.missing_glyphs.join("");
    if (font2 !== font) {
      // name the line and its font
      reason +=
        " (" +
        lines
          .filter((ln) => ln.missing_glyphs.length)
          .map((ln) => `line ${ln.field} ${ln.font}: ${ln.missing_glyphs.join("")}`)
          .join("; ") +
        ")";
    }
    result.review_reasons.push(reason);
  }
  return result;
}

/**
 * Drawing helper (not in the Python engine): where production's PDF puts each
 * character of a laid-out line.  Returns one entry per character (code point):
 * { ch, dx_in } = offset from the line's x_in, from the pack's 1/1000 em
 * advances (the widths written into the production PDF; no kerning, no
 * ligatures).  Placing each character at x_in + dx_in reproduces production
 * glyph positions exactly, whatever the browser's own text shaping does.
 */
function glyphOffsets(pack, font, text, fontSize) {
  const F = asPack(pack).font(font);
  const out = [];
  let sum = 0;
  for (const ch of pyStr(text)) {
    out.push({ ch, dx_in: ((sum * fontSize) * 0.001) / PT });
    sum += F._g(ch)[1];
  }
  return out;
}

/**
 * Production [fs1, fs2] for a "make it bigger" title (port of Python
 * enlarge_font_sizes): the lines sized on their own (approved-acronym sizing),
 * but if laying that out would make the other line smaller than in the normal
 * layout, the growing line is reduced until the other line keeps its normal
 * size, then rounded down to 0.1 pt.  opts: the layoutTitle options.
 */
function enlargeFontSizes(pack, opts = {}) {
  pack = asPack(pack);
  const o = Object.assign({}, opts);
  delete o.enlarge;
  delete o.fontSizes;
  delete o.font_sizes;
  const ori = normOrientation(o.orientation);
  const font = o.font;
  const font2 = o.font2 === undefined || o.font2 === null ? font : o.font2;
  const modeOpt = opt(o, "mixedFontEqualSize", "mixed_font_equal_size");
  const raw1 = pyStr(o.line1);
  const raw2 = pyStr(o.line2);
  const basePfs = productionFontSizes(pack, font, ori, raw1, raw2, font2, modeOpt);
  const bigPfs = productionFontSizes(pack, font, ori, raw1, raw2, font2, modeOpt, true);
  if (!(raw1 && raw2) || (bigPfs[0] === basePfs[0] && bigPfs[1] === basePfs[1])) return bigPfs;
  const base = layoutTitle(pack, Object.assign({}, o, { fontSizes: basePfs }));
  const floor = base.lines.map((ln) => ln.font_size);
  const keeps = (pfs) => {
    const res = layoutTitle(pack, Object.assign({}, o, { fontSizes: pfs }));
    return res.lines.length === floor.length && res.lines.every((ln, i) => ln.font_size >= floor[i] - 1e-9);
  };
  if (keeps(bigPfs)) return bigPfs;
  const g = bigPfs[0] - basePfs[0] >= bigPfs[1] - basePfs[1] ? 0 : 1;
  let lo = basePfs[g];
  let hi = bigPfs[g];
  for (let k = 0; k < 50; k++) {
    const mid = (lo + hi) / 2;
    const pfs = bigPfs.slice();
    pfs[g] = mid;
    if (keeps(pfs)) lo = mid;
    else hi = mid;
  }
  const pfs = bigPfs.slice();
  pfs[g] = Math.max(basePfs[g], Math.floor(lo * 10 + 1e-9) / 10);
  return [pfs[0], pfs[1]];
}

/**
 * "Make it bigger" (port of Python enlarge_option): whether to offer the box for
 * a title, and the enlarged layout.  opts: the layoutTitle options (without
 * fontSizes or enlarge).  Offered for two-line titles when sizing the lines on
 * their own makes a line at least pack.enlarge_min_gain bigger, no line shrinks
 * and the enlarged title needs no review.  Returns { offered, gain, layout }.
 */
function enlargeOption(pack, opts = {}) {
  pack = asPack(pack);
  const o = Object.assign({}, opts);
  delete o.enlarge;
  if (opt(o, "fontSizes", "font_sizes") !== undefined && opt(o, "fontSizes", "font_sizes") !== null) {
    throw new LayoutPackError("enlargeOption computes its own font sizes");
  }
  const base = layoutTitle(pack, o);
  const big = layoutTitle(pack, Object.assign({}, o, { enlarge: true }));
  const out = { offered: false, gain: 0.0, layout: null };
  if (base.lines.length < 2 || big.lines.length !== base.lines.length) return out;
  const ratios = [];
  base.lines.forEach((a, i) => {
    if (a.font_size > 0) ratios.push(big.lines[i].font_size / a.font_size);
  });
  if (ratios.length < 2) return out;
  const gain = Math.max(...ratios) - 1.0;
  out.gain = Math.round(gain * 10000) / 10000;
  if (gain >= pack.enlarge_min_gain - 1e-9 && Math.min(...ratios) >= 1.0 - 1e-9 && !big.needs_review) {
    out.offered = true;
    out.layout = big;
  }
  return out;
}

/** Python-compatibility helpers, exported for the tests only. */
const _py = { pyRound1, pyFormat1, pyFormatG, pyRepr, pyStr, sortedCodePoints };

const BBLayout = {
  ENGINE_VERSION,
  LayoutPack,
  LayoutPackError,
  loadPack,
  validateAcronyms,
  withAcronyms,
  MAX_APPROVED_ACRONYMS,
  layoutTitle,
  enlargeOption,
  enlargeFontSizes,
  productionFontSizes,
  isApprovedAcronym,
  productionStrip,
  glyphOffsets,
};

if (typeof globalThis !== "undefined") globalThis.BBLayout = BBLayout;

})();
